import { TConstructionCard } from "../types/constructionPageTypes"
import { axiosInstance } from "./axiosConfig"

/** Convert hours → seconds for Next fetch revalidate. */
const hoursToSeconds = (hours: number) => Math.max(0, Math.round(hours * 3600))

export const generalGetRequest = async (route: string) => {
	const data = await axiosInstance.get(`${route}`)
	return data
}

export const serverPageFetchRequest = async (
	route: string,
	revalidationValue: number = 24
) => {
	const API_URL = process.env.NEXT_PUBLIC_STATIC_API_URL
	if (route) {
		const res = await fetch(`${API_URL}/${route}`, {
			next: { revalidate: hoursToSeconds(revalidationValue) },
		})

		if (res.ok) {
			const data = await res.json()
			return { sections: data.data.page.sections, page: data.data.page }
		}
	} else {
		console.warn("No link provided to serverSideFetchRequest.")
		return null
	}
}

export const serverConstructionFetchRequest = async (
	route: string,
	revalidationValue: number = 24
): Promise<TConstructionCard[] | null> => {
	const API_URL = process.env.NEXT_PUBLIC_STATIC_BASE_API_URL

	if (!route) {
		console.warn("No link provided to serverSideFetchRequest.")
		return null
	}

	try {
		const res = await fetch(`${API_URL}${route}`, {
			next: { revalidate: hoursToSeconds(revalidationValue) },
		})

		if (res.ok) {
			const data = await res.json()

			return data?.data?.data?.sections?.map((item: any) => ({
				title: item?.title?.en,
				description: item?.description?.en,
				date: item?.date,
				media: item?.media,
				project_name: item?.sectionable?.name?.en,
				project_slug: item?.sectionable?.slug,
				slug: item?.slug,
			}))
		} else {
			console.error("Failed to fetch data:", res.statusText)
			return null
		}
	} catch (error) {
		console.error("Error fetching data:", error)
		return null
	}
}

export const baseServerPageFetchRequest = async (
	route: string,
	returnWithoutModification: boolean = false,
	revalidationValue: number = 24
) => {
	const API_URL = process.env.NEXT_PUBLIC_STATIC_BASE_API_URL

	if (route) {
		const res = await fetch(`${API_URL}${route}`, {
			next: { revalidate: hoursToSeconds(revalidationValue) },
		})

		if (res.ok) {
			const data = await res.json()

			if(returnWithoutModification) return data?.data
			return { sections: data.data.page.sections, page: data.data.page }
		}
	} else {
		console.warn("No link provided to serverSideFetchRequest.")
		return null
	}
}
export const baseServerPageFetchRequestTwo = async (
	route: string,
	revalidationValue: number = 24
) => {
	const API_URL = process.env.NEXT_PUBLIC_STATIC_BASE_API_URL
	
	
	if (route) {
		const res = await fetch(`${API_URL}${route}`, {
			next: { revalidate: hoursToSeconds(revalidationValue) },
		})

		if (res.ok) {
			const data = await res.json()
			
			return { sections: data, }
		}
	} else {
		console.warn("No link provided to serverSideFetchRequest.")
		return null
	}
}
